'use client';

import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Badge } from '@flipster/react/design-system/badge';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { CurrencyDisplay } from '../../../../../misc/display';
import { useProductConfig } from '../../product-config';

export const ProductInfo = () => {
  const router = useRouter();
  const { currency, strategyProviderPath, strategyProviderLink } = useProductConfig();

  return (
    <>
      <div
        className={css({
          display: 'flex',
          tabletDown: { flexDirection: 'column', gap: 8 },
          tablet: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
        })}
      >
        <CurrencyDisplay
          currency={currency}
          icon={<CurrencyDisplay.Icon size={32} space={12} />}
          mainLabel={
            <CurrencyDisplay.Label value='fullName' css={{ textStyle: 'Title/L', color: 'content.default.level-5' }} />
          }
        />
        {strategyProviderPath && (
          <button
            type='button'
            onClick={() => router.push(strategyProviderPath)}
            className={hstack({
              gap: 4,
              textStyle: 'Text/M/Regular',
              color: 'content.default.level-2',
              flexShrink: 0,
            })}
          >
            {strategyProviderLink ?? <FormattedMessage id='Earn.r260224.Strategy_provider_link' />}
            <ChevronRightIcon className={css({ w: 16, h: 16 })} />
          </button>
        )}
      </div>

      <div className={hstack({ gap: 8, flexWrap: 'wrap' })}>
        <Badge type='tint' color='positive'>
          <FormattedMessage id='Earn.r260224.Strategy_keyword_1' />
        </Badge>
        <Badge type='tint' color='neutral'>
          <FormattedMessage id='Earn.r260224.Strategy_keyword_2' />
        </Badge>
        <Badge type='tint' color='neutral'>
          <FormattedMessage id='Earn.r260224.Strategy_keyword_3' />
        </Badge>
        <Badge type='tint' color='neutral'>
          <FormattedMessage id='Earn.r260224.Strategy_keyword_4' />
        </Badge>
      </div>
    </>
  );
};
